import { useTranslation } from 'react-i18next'
import { Alert, AlertProps, AlertTitle, Button, Stack } from '@mui/material'
import { Valve } from '../types'
import ValveDetachOutRuuviTagButton from './ValveDetachOutRuuviTagButton'

export interface ValveDetachOutRuuviTagAlertProps
  extends Omit<AlertProps, 'children' | 'onChange'> {
  valve: Valve
  onValveChange?: (valve: Valve) => void
  onCancel?: () => void
}

export default function ValveDetachOutRuuviTagAlert({
  valve,
  onValveChange,
  onCancel,
  sx,
  ...props
}: ValveDetachOutRuuviTagAlertProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('valve')

  /**
   * Handle the "after submit" event.
   */
  function handleAfterSubmit(valve: Valve) {
    onValveChange?.(valve)
  }

  return (
    <>
      {valve?.outRuuviTagId !== null && (
        <Alert
          severity="info"
          sx={{
            '& .MuiAlert-message': {
              width: '100%'
            },
            ...sx
          }}
          {...props}
        >
          <AlertTitle sx={{ m: 0 }}>{t('ValveDetachOutRuuviTagAlert.title')}</AlertTitle>

          <Stack direction="row" alignItems="center" gap={2} sx={{ mt: 2 }}>
            <ValveDetachOutRuuviTagButton
              valve={valve}
              variant="outlined"
              color="inherit"
              size="small"
              buttonText={t('ValveDetachOutRuuviTagAlert.yes')}
              afterSubmit={handleAfterSubmit}
            />

            <Button variant="outlined" color="inherit" size="small" onClick={onCancel}>
              {t('ValveDetachOutRuuviTagAlert.no')}
            </Button>
          </Stack>
        </Alert>
      )}
    </>
  )
}
